<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{$t('info')}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="130px">
            <el-form-item :label="$t('logo_img')" prop="img_lnk">
                <myCropImg :autoCropWidthHeight="[400,400]" crop_height="450px" crop_width="450px" :original_url="formData.img_lnk" @cropImgUpload="setOrgIcon"></myCropImg>
            </el-form-item>
            <el-form-item :label="$t('build_img')">
                <myCropImg :autoCropWidthHeight="[600,360]" crop_height="500px" crop_width="700px" :original_url="formData.build_img_lnk" @cropImgUpload="setOrgBuildImg"></myCropImg>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('code')" prop="org_code">
                        <el-input v-model="formData.org_code" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('org_cname')" prop="org_cname">
                        <el-input v-model="formData.org_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('link_cname')">
                        <el-input class="width-120" v-model="formData.link_cname" disabled></el-input>
                        <el-input style="width: 226px" v-model="formData.link_mobile" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('org_admin_code')" prop="org_admin_code" >
                        <el-input v-model="formData.org_admin_code" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('cu_cname')">
                        <el-input class="width-120" v-model="formData.cu_cname" :placeholder="$t('input')"></el-input>
                        <el-input style="width: 226px" v-model="formData.cu_mobile" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('cu_time_area')" prop="cu_time_area">
                        <el-input v-model="formData.cu_time_area" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--省市区选择-->
            <el-form-item :label="$t('addr2')" prop="addrLabel">
                <el-cascader class="fillw" :options="addrData" trigger="click" :filterable="true" v-model="formData.addrLabel"
                             ref="ref_addr" @change="addrValueChang" :props="{value:'label'}"></el-cascader>
            </el-form-item>
            <!--详细地址-->
            <el-form-item :label="$t('addr')" prop="addr">
                <el-input v-model="formData.addr" :placeholder="$t('input')"></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="12"><el-form-item :label="$t('add_user')"><el-input v-model="formData.add_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('add_time')"><el-input v-model="formData.add_time" disabled></el-input></el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item :label="$t('upd_user')"><el-input v-model="formData.upd_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('upd_time')"><el-input v-model="formData.upd_time" disabled></el-input></el-form-item></el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    import myCropImg from '../../../components/myCropImg.vue'
    import addr from '../../../utils/addr/index'
    export default {
        components: {
            myCropImg,
        },
        data:function(){
            return{
                relist:false,
                formData: {
                    org_id: "",
                    mod_id: "",
                    img_lnk: "",
                    build_img_lnk: "",
                    org_code: "",
                    org_cname: "",
                    link_cname: '',
                    link_mobile: '',
                    org_admin_code: "",
                    cu_cname: "",
                    cu_mobile: "",
                    cu_time_area: '',
                    lng: '',
                    lat: '',
                    prov: "",
                    city: "",
                    area: "",
                    addr: "",
                    addrLabel: [],
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                addrData: [],
                rule: {
                    img_lnk: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    org_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cu_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cu_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cu_time_area: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    addrLabel: [{required: true, message: this.$t('select'), trigger: 'change', type:'array'}],
                    addr: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                },
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.func_id = this.$base.getRequest().id;
            this.getInfo();
            setTimeout(() => {
                this.addrData = addr.getAddrData()
            }, 500)
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            setOrgIcon: function (file_path) {
                this.formData.img_lnk = file_path;
            },
            setOrgBuildImg: function (file_path) {
                this.formData.build_img_lnk = file_path;
            },
            addrValueChang(value){
                this.formData.prov = value[0];
                this.formData.city = value[1];
                this.formData.area = value[2];
            },
            getInfo: function(){
                var data = {
                };
                this.$base.showLoading();
                this.$request.sendPost("org/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.formData.addrLabel=[this.formData.prov,this.formData.city,this.formData.area];
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost("org/upd",this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    }  else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/org/info/info_save.vue